import script from "./Document.vue?vue&type=script&setup=true&lang=js"
export * from "./Document.vue?vue&type=script&setup=true&lang=js"

import "./Document.vue?vue&type=style&index=0&id=e9a561dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9a561dc"]])

export default __exports__